import { useEffect, useRef } from "react";

const useIntersect = (callback: (entries: IntersectionObserverEntry[]) => void) => {
    // Create a ref for the target element
    const target = useRef<HTMLDivElement | null>(null);

    // Create an intersection observer instance with the callback and options
    const observer = useRef<IntersectionObserver>(
        new IntersectionObserver((entries) => callback(entries), {
            root: null, // use the viewport as the root
            rootMargin: "0px", // no margin around the root
            threshold: 0.5 // trigger when the element is fully visible
        })
    );

    // Attach the observer to the target element on mount and detach on unmount
    useEffect(() => {
        if (target.current) observer.current.observe(target.current);
        return () => {
            if (target.current) observer.current.unobserve(target.current);
        };
    }, []);

    // Return the target ref
    return target;
};

export default useIntersect;
